<template>
    <div class="edit-address-page">
        <van-sticky>
            <van-nav-bar
                title="我的地址"
                :style="{'paddingTop':statusBarHeight,'backgroundColor':'#FFFFFF'}"
                left-arrow
                right-text="删除"
                @click-left="handleBack"
                @click-right="onDelete"
            />
        </van-sticky>
        <van-address-edit
            safe-area-inset-bottom
            :area-list="areaList"
            show-set-default
            :area-columns-placeholder="['请选择', '请选择', '请选择']"
            area-placeholder="选择地区"
            :address-info="AddressInfo"
            :tel-maxlength="11"
            @save="onSave"
            @delete="onDelete"
            @change-detail="onChangeDetail"
            :validator="validator"
        />
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { areaList } from '@vant/area-data';
export default {
    data() {
        return {
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            statusBarHeight: 0,
            bottomSafeHeight: 0,
            AddressInfo: {},
            areaList,
            uuid: this.$route.query.uuid || '',
            num: this.$route.query.num || '',
            id: this.$route.params.id,
            goodsKinds: this.$route.query.goodsKinds || '',
            goodsId: this.$route.query.id || '',
        };
    },
    created() {
        this.setCompatible();
        if(this.id) {
            this.getData()
        }
    },
    mounted () {
        document.getElementsByClassName('van-button')[0].style.marginBottom = this.bottomSafeHeight;
    },
    methods: {
        setCompatible() {
            if(localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
                this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
            }
        },
        getData() {
            this.$api.address.getAddressDetail(
                {
                    id: this.id,
                }
            ).then((res)=>{
                const {defaultFlag, addr, receiver,province, city, area, mobile, areaId} = res.data;
                this.AddressInfo = {
                    name: receiver,
                    areaCode: String(areaId),
                    tel: mobile,
                    city: city,
                    county: area,
                    province: province,
                    addressDetail: addr,
                    isDefault: defaultFlag ? true : false,
                }

            })
            
        },
        validator(key,val) {
            if(key === 'name') {
                if(val.length > 10)
                return '名字长度不能大于10'
            }
        },
        onSave(result) {
            const {name: receiver,isDefault, areaCode: areaId, addressDetail: addr, province, city, county: area, tel: mobile} = result;
            // 地区code 前两位代表省 中间两位代表市
            const  provinceCode = `${areaId.slice(0, 2)}`
            const  cityCode = `${areaId.slice(2, 4)}`
            
            const params = {
                receiver,
                defaultFlag: isDefault? 1: 0,
                addr,
                province,
                areaId,
                provinceId:`${provinceCode}0000`,
                cityId: `${provinceCode}${cityCode}00`,
                city,
                area,
                mobile,
                id: this.id,
            }
            
            this.$api.address.saveAddress(params).then((res)=>{
                if(res.success) {
                    Toast('保存成功')
                    // let url
                    // if (this.uuid) {
                    //     if (this.goodsKinds == 5) {
                    //         url = `/address/list?uuid=${this.uuid}&num=${this.num}&goodsKinds=5&id=${this.goodsId}`
                    //     } else {
                    //         url = `/address/list?uuid=${this.uuid}&num=${this.num}`
                    //     }
                    // } else {
                    //     url = '/address/list'
                    // }
                    // this.$router.push(url);
                    this.$router.go(-1)
                }
            })
        },
        onDelete() {
            Dialog.confirm({
                title: '',
                message: '是否删除该地址',
                width: '15rem',
                theme: 'app-theme',
                confirmButtonText: '确认删除',
                confirmButtonColor: '#1F94FF'
            })
            .then(() => {
                this.$api.address.deleteAddress([Number(this.id)]).then((res)=>{
                    if(res.success) {
                        Toast('删除成功');
                        this.$router.go(-1);
                        // let url = '/address/list'
                        // if(this.uuid) {
                        //     if (this.goodsKinds == 5) {
                        //         url = `/address/list?uuid=${this.uuid}&goodsKinds=5&id=${this.goodsId}`;
                        //     } else {
                        //         url = `/address/list?uuid=${this.uuid}`;
                        //     }
                        // }
                        // this.$router.replace(url)
                    }
                })
            })
            
        },
        onChangeDetail() {
            console.log('dere')
        },
        handleBack() {
            let url
            // if (this.uuid) {
            //     if (this.goodsKinds == 5) {
            //         url = `/address/list?uuid=${this.uuid}&num=${this.num}&goodsKinds=5&id=${this.goodsId}`
            //     } else {
            //         url = `/address/list?uuid=${this.uuid}&num=${this.num}`
            //     }
            // } else {
            //     url = '/address/list'
            // }
            this.$router.go(-1);
            
            // this.$router.replace(url);
        }
    },
};
</script>
<style lang="less">
    body {
        background-color: #F8FAFC;
    }
    .van-picker__cancel,.van-picker__confirm {
        font-size: 16px;
    }
    .van-picker__cancel {
        color: #999999;
    }
    .van-picker__confirm {
        color: #1F94FF;
    }
</style>
<style lang="less" scoped>
    .px2rem(@name,@px){
        @{name}: @px / 37.5px * 1rem
    }
    ::v-deep {
        .van-address-edit {
            padding: 0;
        }
        .van-picker__cancel,.van-picker__confirm {
            .px2rem(font-size, 32);
        }
        .van-cell {
            .px2rem(padding-top, 34);
            .px2rem(padding-right, 32);
            .px2rem(padding-bottom, 34);
            .px2rem(padding-left, 32);
        }
        .van-field__control {
            .px2rem(font-size, 30);
        }
        .van-address-edit-detail {
            padding: 0;
        }
        .van-address-edit__fields {
            padding: 0;
            .van-cell__title {
                display: none;
            }
        }
        .van-address-edit__default {
            color: #333;
            .px2rem(font-size, 30);
            .van-switch {
                padding: 0.125rem;
                background-color: #D8D8D8;
                border: 0 none;
                box-sizing: border-box;
                .px2rem(width, 96);
                .px2rem(height, 56);
                .px2rem(border-radius, 28);
            }
            .van-switch--on {
                background-color: #1F94FF;
                .van-switch__node {
                    transform: translateX(1.25rem);
                }
            }
            .van-switch__node {
                .px2rem(width, 48);
                .px2rem(height, 48);
                .px2rem(top, 4);
                .px2rem(left, 4);
            }
        }
        .van-address-edit__buttons {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            box-sizing: border-box;
            padding: 0.24rem 0.85rem;
            background-color: #fff;
            box-shadow: inset 0px 1px 0px 0px #EAEAEA;
            .van-button {
                background-color: #1F94FF;
                border-color: #1F94FF;
                margin-bottom: 0;
                .px2rem(height, 80);
            }
        }
    }
</style>